import type { CheckoutSession } from 'models';
import { fetchJson } from 'utils/fetchJson/fetchJson';

import { createMapper } from './mappers/create';

export type CheckoutSessionType =
  | 'card_tokenization_for_installment'
  | 'card_tokenization_for_one_off'
  | 'direct_debit_tokenization_for_installment'
  | 'new_mandate';

export type DirectDebitProcessor = 'BMOC' | 'CRBA' | 'FINA' | 'SEPA';

export type PayorDetails = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  country: string;
  state: string;
  zip: string;
};

export type MandateAch = {
  initDate: string;
  finalDate: string;
  numberOfPayments: number;
};

export type CreateSessionPayload = {
  sessionType: CheckoutSessionType;
  recipientId?: string;
  paymentMethodToken?: string;
  directDebitProcessor?: DirectDebitProcessor;
  payor?: PayorDetails;
  mandateAch?: MandateAch;
};

export type CreateSessionParams = CreateSessionPayload & {
  accessToken?: string;
  locale: string;
};

type SessionsService = {
  create: (params: CreateSessionParams) => Promise<CheckoutSession>;
};

export const sessions: SessionsService = {
  create: async ({ accessToken, locale, ...rest }) => {
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(createMapper.mapToBackend(rest)),
    };
    const options = {} as Record<string, unknown>;

    if (accessToken) {
      options.headers = { Authorization: `Bearer ${accessToken}` };
    }

    return fetchJson(`/sessions?locale=${locale}`, {
      ...requestOptions,
      ...options,
    });
  },
};
